class Project {
    constructor(attributes = {}) {
        Object.assign(this, attributes)
    }
    equals = (other) => other && (this.name === other.name)
}

export default Project